import { Paper, Button, SxProps, Theme } from "@mui/material";
import BodyText from "../../../components/BodyText";
import SmallText from "../../../components/Smalltext";
import EmailMismatchImg from "../../../assets/email-mismatch.png";

interface Props {
  paperSx: SxProps<Theme>;
  onContactCustomerSupport: () => void;
  onEmailMismatchUpdate: () => void;
  newEmail: string;
}

const EmailMismatchView = ({
  onContactCustomerSupport: contactCustomerSupportHandler,
  onEmailMismatchUpdate: emailMismatchUpdateHandler,
  paperSx,
  newEmail,
}: Props) => (
  <Paper sx={paperSx} elevation={3}>
    <div style={{ padding: "30px", textAlign: "center" }}>
      <img
        src={EmailMismatchImg}
        alt="Email Mismatch"
        style={{ width: 50, height: 50, marginBottom: 10 }}
      />
      <BodyText sx={{ fontWeight: 600, fontSize: "18px", mb: 0.5 }}>
        Email does not match
      </BodyText>
      <SmallText
        sx={{ fontWeight: 500, color: "#888072", fontFamily: "Roboto" }}
      >
        The purchased plan is assigned to an email that is different from your
        verified email address. Confirm the email address below to continue to
        activate.
      </SmallText>
      <BodyText sx={{ fontWeight: 500, color: "#888072", fontSize: "15px" }}>
        {newEmail}
      </BodyText>
    </div>

    <div style={{ paddingLeft: "1", paddingRight: "1" }}>
      <Button
        variant="outlined"
        color="secondary"
        sx={{ width: "100%", px: 5 }}
        onClick={emailMismatchUpdateHandler}
        fullWidth
      >
        Confirm and Activate
      </Button>
    </div>
    <Button variant="text" onClick={contactCustomerSupportHandler}>
      Contact customer support for assistance.
    </Button>
  </Paper>
);
export default EmailMismatchView;
